class Teams {

    constructor(_request) {
        this._request = _request;
    }

    list() {
        return this._request.fetch({method: "GET", endpoint: "teams"});
    }

    members() {
        return this._request.fetch({method: "GET", endpoint: "teams/members"});
    }
    
}

export default Teams;
